import BarclaysLogo from '../../tradingData/linkedAccounts/providerLogos/Barclays.svg';
import HSBCLogo from '../../tradingData/linkedAccounts/providerLogos/HSBC.svg';
import LloydsLogo from '../../tradingData/linkedAccounts/providerLogos/Lloyds.svg';
import NatwestLogo from '../../tradingData/linkedAccounts/providerLogos/Natwest.svg';

// Branded logos keyed by the bank name variants the provider field can take
// (the API returns e.g. "Natwest" while the legacy map used "Natwest Bank").
const BRANDED_LOGOS: Record<string, string> = {
    barclays: BarclaysLogo,
    'barclays bank': BarclaysLogo,
    hsbc: HSBCLogo,
    'hsbc bank': HSBCLogo,
    lloyds: LloydsLogo,
    'lloyds bank': LloydsLogo,
    natwest: NatwestLogo,
    'natwest bank': NatwestLogo
};

/**
 * Returns a branded bank logo asset URL for a given bank name, or undefined if
 * we don't have one. Used as a fallback when the API context provides no
 * `logo_url` for a linked account.
 */
export const getBankLogo = (bankName?: string): string | undefined => {
    if (!bankName) return undefined;
    return BRANDED_LOGOS[bankName.toLowerCase()];
};
